module.exports = __webpack_public_path__ + "assets/img/ab47-sc.svg";